// Shared helper to transpile user-authored TypeScript into plain JavaScript
// eslint-disable-next-line import/no-extraneous-dependencies
import ts from 'typescript'

type TranspileOptions = {
  stripImports?: RegExp
  stripExports?: boolean
}

const stripCode = (code: string, { stripImports, stripExports }: TranspileOptions = {}) => {
  let result = code
  if (stripImports) result = result.replace(stripImports, '')
  if (stripExports) result = result.replace(/export\s+(default\s+)?/gi, '')
  return result
}

const transpileTypeScript = (code: string, options?: TranspileOptions) =>
  ts.transpileModule(stripCode(code, options), {
    compilerOptions: {
      target: ts.ScriptTarget.ES2018,
      module: ts.ModuleKind.None,
    },
  }).outputText

export default transpileTypeScript
